import type { CountryCode } from '@7f-ui/components/country-select/country-select'
import { CountryCodes } from '@7f-ui/components/country-select/country-select'

export function isCountryCode(code: string | null | undefined): code is CountryCode {
  return CountryCodes.some(value => value === code)
}
